export default __webpack_public_path__ + "static/media/1493.d728a717.png";